import React, { use, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import images from "../../../constant/images";
import { storeToken } from "../../../formSlice";
import "./testo.css";

export const Testimonials = () => {
  const language = localStorage.getItem("i18nextLng");
  const { i18n, t } = useTranslation();
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [types, setTypes] = useState([]);
  const navigationRefs = useRef({});
  const lang = i18n.language;
  useEffect(() => {
    let active = true;
    const fetchTestimonials = async () => {
      setIsLoading(true);
      try {
        const { data } = await axios.get(`${baseUrl}/testimonials`);
        if (!active) return;

        const sortedTypes = data.types.sort((a, b) => a.order - b.order);
        setTypes(sortedTypes);
      } catch (err) {
        console.error(err);
      } finally {
        if (active) setIsLoading(false);
      }
    };
    fetchTestimonials();
    return () => {
      active = false;
    };
  }, [baseUrl]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [video, setVideo] = useState("");

  const [user, setUser] = useState();
  const [membership, setMembership] = useState();
  const dispatch = useDispatch();

  const fetchData = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(response.data);
        setMembership(response.data?.membership);

        dispatch(storeToken(token));
      }
    } catch (error) {

    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {isModalOpen && (
        <div className="modal fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[9999] p-4">
          <div className="modal-video relative w-full max-w-6xl aspect-video bg-black">
            <button
              className="modal-close absolute -top-12 right-0 text-white text-4xl hover:text-gray-300 transition-colors"
              onClick={() => setIsModalOpen(false)}
            >
              ×
            </button>
            <video className="w-full h-full" controls autoPlay src={video}>
              <source src={video} type="video/mp4" />
            </video>
          </div>
        </div>
      )}
    {/* <div className="bg-white bg-opacity-[87%] h-full flex flex-col justify-center items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-8 md:py-16"> */}
      
          <div className="bg-white bg-opacity-[87%] h-full flex flex-col gap-6 w-full md:w-[100%]  rounded-3xl shadow-custom py-6 md:py-12 ">
            <div className="min-h-screen   ">
              <div className="mx-auto px-4 sm:px-6 lg:px-8">
                <div id="Temoignages" className=" rounded-xl  ">
                  {isLoading ? (
                    <div className="flex justify-center items-center h-64">
                      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
                    </div>
                  ) : (
                    <div className="space-y-14">
                      <h1 className="text-3xl testimo sm:text-4xl font-bold text-center mb-10 relative pb-2 ">
                        {t("aboutUs_content.testimonials")}
                      </h1>
                      <style>
                        {`
                    .testimo::after {
                      content: '';
                      position: absolute;
                      width: 20%;
                      height: 5px;
                      bottom: -2px;
                      left: 50%;
                      transform: translateX(-50%);
                      background-color: ${
                        membership?.membership_packs?.color || "#608D40"
                      };
                    }
                    

                    `}
                      </style>
                      {types?.map((item) => {
                        if (item.testimonials.length > 0) {
                          if (!navigationRefs.current[item.id]) {
                            navigationRefs.current[item.id] = {
                              prevRef: React.createRef(),
                              nextRef: React.createRef(),
                            };
                          }
                          const { prevRef, nextRef } =
                            navigationRefs.current[item.id];
                          return (
                            <div key={item.id} className="space-y-8">
                              <h2
                                className="text-2xl md:text-3xl font-bold text-center bg-gray-100 py-5 px-6 rounded-xl shadow-lg p-6"
                                style={{
                                  borderLeft: `${
                                    membership?.membership_packs?.color ||
                                    "#608D40"
                                  } solid 4px`,
                                }}
                              >
                                {language === "fr"
                                  ? `${item.fr_name}`
                                  : `${item.name}`}
                              </h2>

                              <div className="relative px-12">
                                <button
                                  ref={prevRef}
                                  className="absolute buttons top-1/2 left-[-30px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md   transition-all"
                                  style={{}}
                                >
                                  <FaAngleLeft />
                                </button>

                                <button
                                  ref={nextRef}
                                  className="absolute buttons top-1/2 right-[-30px] transform -translate-y-1/2 z-10 text-2xl rounded-full text-black p-4 bg-white shadow-md   transition-all"
                                >
                                  <FaAngleRight />
                                </button>

                                <style>
                                  {`
                                  .buttons:hover {
                                    background-color: ${membership?.membership_packs?.color};
                                    color: white;
                                  }
                                  `}
                                </style>

                                <Swiper
                                  spaceBetween={25}
                                  loop={true}
                                  breakpoints={{
                                    0: { slidesPerView: 1 },
                                    768: { slidesPerView: 2 },
                                    1024: { slidesPerView: 3 },
                                  }}
                                  navigation={{
                                    prevEl: prevRef.current,
                                    nextEl: nextRef.current,
                                  }}
                                  modules={[Navigation, Pagination]}
                                  autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                  }}
                                  onSwiper={(swiper) => {
                                    setTimeout(() => {
                                      const { prevRef, nextRef } =
                                        navigationRefs.current[item.id];

                                      if (
                                        swiper.params &&
                                        swiper.params.navigation &&
                                        prevRef.current &&
                                        nextRef.current
                                      ) {
                                        swiper.params.navigation.prevEl =
                                          prevRef.current;
                                        swiper.params.navigation.nextEl =
                                          nextRef.current;

                                        if (
                                          swiper.navigation &&
                                          typeof swiper.navigation.init ===
                                            "function"
                                        ) {
                                          swiper.navigation.init();
                                          swiper.navigation.update();
                                        }
                                      }
                                    }, 0);
                                  }}
                                  className="w-full"
                                >
                                  {item.testimonials?.map(
                                    (testimonial, idx) => (
                                      <SwiperSlide key={idx}>
                                        <div className="border bg-[#ebebeb] border-black p-4 relative group h-full">
                                          <div className="video-container relative h-96 w-full">
                                            <video
                                              className="video-background absolute inset-0 w-full h-full object-cover"
                                              loop
                                              muted
                                            >
                                              <source
                                                src={testimonial.url}
                                                type="video/mp4"
                                              />
                                            </video>

                                            <div className="video-overlay absolute inset-0 bg-black bg-opacity-60"></div>

                                            <div className="absolute inset-0 flex items-center justify-center">
                                              <div
                                                className="w-16 h-16 cursor-pointer transition-transform duration-300 group-hover:scale-110"
                                                onClick={() => {
                                                  setVideo(testimonial.url);
                                                  setIsModalOpen(true);
                                                }}
                                              >
                                                <svg
                                                  viewBox="0 0 24 24"
                                                  fill="white"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path d="M8 5v14l11-7z" />
                                                </svg>
                                              </div>
                                            </div>
                                          </div>
                                          <h3 className="mt-4 text-center text-lg font-medium">
                                            {testimonial.name}
                                          </h3>
                                        </div>
                                      </SwiperSlide>
                                    )
                                  )}
                                </Swiper>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
       
    </>
  );
};
